// @owner ClientPlatform

import type {FC} from 'react';
import React, {useId} from 'react';
import {styled} from 'styled-components';

const StyledSvg = styled.svg`
  width: 112px;
  height: auto;
  color: var(--color-text-primary);
`;

interface FrontLogoProps {
  className?: string;
}

export const FrontLogo: FC<FrontLogoProps> = ({className}) => {
  const clipId = useId();
  return (
    <StyledSvg
      className={className}
      width="151"
      height="36"
      viewBox="0 0 151 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Front logo"
    >
      <g clipPath={`url(#${clipId})`}>
        <path d="M0 35.2941H11.8676V11.8191H35.5294V0H0V35.2941Z" fill="#A857F1" />
        <path
          d="M25.2938 36C31.2065 36 35.9997 31.2068 35.9997 25.2941C35.9997 19.3814 31.2065 14.5883 25.2938 14.5883C19.3811 14.5883 14.5879 19.3814 14.5879 25.2941C14.5879 31.2068 19.3811 36 25.2938 36Z"
          fill="#A857F1"
        />
        <path
          d="M144.052 34.8021C141.866 34.8021 140.185 34.2255 139.008 33.0724C137.854 31.9194 137.278 30.2378 137.278 28.0277V17.5777H132.846V11.488H137.278V3.56042H144.665V11.488H150.971V17.5777H144.665V26.4782C144.665 27.2229 144.857 27.7874 145.241 28.1718C145.626 28.5562 146.19 28.7483 146.935 28.7483H150.971V34.8021H144.052Z"
          fill="currentColor"
        />
        <path
          d="M108.376 11.4877H115.078V13.4335C115.847 12.5927 116.784 11.9441 117.889 11.4877C119.018 11.0072 120.267 10.755 121.637 10.731C122.982 10.7069 124.243 10.9352 125.42 11.4156C126.597 11.8961 127.618 12.5687 128.483 13.4335C129.348 14.3224 130.009 15.4154 130.465 16.7126C130.945 17.9859 131.186 19.5473 131.186 21.3971V34.8018H123.763V22.1538C123.763 21.1929 123.666 20.4482 123.474 19.9197C123.306 19.3672 123.03 18.8987 122.646 18.5144C121.949 17.8417 121 17.5054 119.799 17.5054C118.598 17.5054 117.649 17.8417 116.952 18.5144C116.544 18.8987 116.243 19.3672 116.051 19.9197C115.883 20.4482 115.799 21.1929 115.799 22.1538V34.8018H108.376V11.4877Z"
          fill="currentColor"
        />
        <path
          d="M92.7632 35.4145C90.3369 35.4145 88.1268 34.874 86.1329 33.793C84.1631 32.736 82.6016 31.2586 81.4485 29.3608C80.3194 27.487 79.7549 25.409 79.7549 23.1269C79.7549 20.8447 80.3194 18.7547 81.4485 16.8569C82.6016 14.9591 84.1631 13.4697 86.1329 12.3887C88.1268 11.2836 90.3369 10.7311 92.7632 10.7311C95.1895 10.7311 97.3876 11.2836 99.3575 12.3887C101.351 13.4697 102.913 14.9591 104.042 16.8569C105.171 18.7547 105.736 20.8447 105.736 23.1269C105.736 25.409 105.171 27.487 104.042 29.3608C102.913 31.2586 101.351 32.736 99.3575 33.793C97.3876 34.874 95.1895 35.4145 92.7632 35.4145ZM92.7632 28.8563C93.7722 28.8563 94.673 28.6041 95.4658 28.0996C96.2826 27.5951 96.9192 26.9104 97.3756 26.0456C97.832 25.1808 98.0603 24.2079 98.0603 23.1269C98.0603 22.0458 97.832 21.0729 97.3756 20.2081C96.9192 19.3433 96.2826 18.6706 95.4658 18.1902C94.673 17.6857 93.7722 17.4334 92.7632 17.4334C91.7303 17.4334 90.8054 17.6857 89.9886 18.1902C89.1958 18.6706 88.5713 19.3433 88.1148 20.2081C87.6584 21.0729 87.4302 22.0458 87.4302 23.1269C87.4302 24.2079 87.6584 25.1808 88.1148 26.0456C88.5713 26.9104 89.2079 27.5951 90.0246 28.0996C90.8414 28.6041 91.7543 28.8563 92.7632 28.8563Z"
          fill="currentColor"
        />
        <path
          d="M63.3154 11.4876H69.9818V14.2622C70.7745 13.2773 71.7234 12.5206 72.8285 11.9921C73.9575 11.4636 75.1707 11.1993 76.4679 11.1993C77.3087 11.1993 78.1255 11.2714 78.9182 11.4155V18.4062C78.3417 18.19 77.5489 18.0819 76.54 18.0819C74.7623 18.0819 73.357 18.6224 72.324 19.7034C71.7715 20.2559 71.3511 20.9286 71.0628 21.7213C70.7985 22.5141 70.6664 23.5351 70.6664 24.7842V34.8018H63.3154V11.4876Z"
          fill="currentColor"
        />
        <path
          d="M42.0605 -0.367432H60.9425V6.65924H49.6638V13.5418H60.7263V20.3162H49.6638V34.802H42.0605V-0.367432Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="151" height="36" fill="white" />
        </clipPath>
      </defs>
    </StyledSvg>
  );
};
